require('raty-js/lib/jquery.raty');
import processJsonErrors from "./lib/bootstrap-errors";

export default function ratings() {
    let form = document.getElementById('review_form');
    if (form) {
        // Handle ratings and verify that they have been selected
        $('.raty').raty({starType: 'i', scoreName: 'review[stars]'});
        $(form).submit(function (e) {
            let ratingValue = $('.raty input[name="review[stars]"]').val();
            if (!ratingValue) {
                alert("Please select a rating for your review.");
                e.preventDefault();
                return false;
            }
        });

        // Handle successful review form submission
        form.addEventListener('ajax:success', function () {
            form.outerHTML = document.getElementById('review_success').innerHTML;
        })

        // Handle failed review form submission
        form.addEventListener('ajax:error', function (e) {
            processJsonErrors('review', e)
        });
    }
}